import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faTimes,
    faQuoteRight,
    faChevronLeft,
    faChevronRight,
} from '@fortawesome/free-solid-svg-icons';

export default {
    init() {
        library.add(
            faTimes,
            faQuoteRight,
            faChevronLeft,
            faChevronRight,
        );

        Vue.component('fa', FontAwesomeIcon);
    },
};
